import { createRouter, createWebHistory } from 'vue-router'
import Home                               from '@/views/Page-Home'
import schematics                         from '@/views/Page-schematics'
import Analyse                            from '@/views/Page-AnalyseSchemas'
import Assembly                           from '@/views/Page-Assembly'
import Filament                           from '@/views/Page-Filament'
import Resine                           from '@/views/Page-Resine'
import conception3D                          from '@/views/Page-conception3D.vue'

const router = createRouter({
    // history: createWebHistory(),
    history: createWebHistory(process.env.BASE_URL), 
    
    
    routes: [
        {
            name: "Home",
            path: '/',
            component: Home
        },
        {
            name: "schematics",
            path: '/schematics',
            component: schematics
        },
        {
            name: "Analyse",
            path: '/analyse',
            component: Analyse
        },
        {
            name: "Assembly",
            path: '/assembly',
            component: Assembly
        },
        {
            name: "Filament",
            path: '/filament',
            component: Filament
        },
        {
            name: "Resine",
            path: '/resine',
            component: Resine
        },
        {
            name: "conception3D",
            path: '/conception3D',
            component: conception3D
        },
        
        
    ],
    scrollBehavior(/*to, from, savedPosition*/) {
        // always scroll to top
        return { top: 0 }
    },

      
})


export default router;

